import { render } from "./index.vue?vue&type=template&id=3d8786ac"
import script from "./featuresBenefits?vue&type=script&lang=js&external"
export * from "./featuresBenefits?vue&type=script&lang=js&external"

import "./featuresBenefits.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__